import { EFieldType } from "#models/questionnaire";
import { SvgIconComponent } from '@material-ui/icons';

export const isEmail = (value: any) => {
  const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return emailPattern.test(value);
};

export const getDefaultValue = (type: EFieldType) => {
  switch (type) {
    case EFieldType.Address:
    case EFieldType.CompanyName:
    case EFieldType.CompanyURL:
    case EFieldType.Email:
    case EFieldType.PhoneNumber:
    case EFieldType.FirstName:
    case EFieldType.LastName:
    case EFieldType.TextBox:
    case EFieldType.DatePicker:
    case EFieldType.TimePicker:
      return '';
    case EFieldType.Checkbox:
      return 0;
    default:
      return '';
  }
};

export const getStartIcon = (type: EFieldType): SvgIconComponent | null => {
  switch (type) {
    case EFieldType.DatePicker:
    case EFieldType.TimePicker:
    case EFieldType.FirstName:
    case EFieldType.LastName:
    case EFieldType.Address:
    case EFieldType.Email:
    case EFieldType.PhoneNumber:
    case EFieldType.TextBox:
    case EFieldType.CompanyName:
    case EFieldType.CompanyURL:
    case EFieldType.Checkbox:
      return null;
    default:
      return null;
  }
};
